'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["properties"];
import { Fragment } from 'react';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { HR } from 'foundations-components/transitional/components/HR';
import { Box } from 'foundations-components/transitional/components/Box';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PropertiesList from 'FormsUI/components/editor/leftPanel/properties/PropertiesList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getLangKey = sufix => `editor.form.properties.${sufix}`;
const FrequentlyUsedProperties = _ref => {
  let {
      properties = []
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(Flex, {
      padding: "600",
      paddingBlockStart: "800",
      "data-tour-step": "frequently-used-properties",
      "data-test-id": "frequently-used-properties",
      children: /*#__PURE__*/_jsx(Box, {
        "data-tour-step": "frequently-used-properties-fields",
        grow: 1,
        children: /*#__PURE__*/_jsx(AccordionItem, {
          "data-test-id": "frequently-used-properties-accordion",
          title: /*#__PURE__*/_jsx(Text, {
            as: "h7",
            marginBlockEnd: "300",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: getLangKey('frequentlyUsed')
            })
          }),
          defaultOpen: true,
          children: /*#__PURE__*/_jsx(PropertiesList, Object.assign({
            properties: properties
          }, rest))
        })
      })
    }), /*#__PURE__*/_jsx(HR, {
      margin: "0"
    })]
  });
};
export default FrequentlyUsedProperties;